import SignalWifiOffIcon from '@mui/icons-material/SignalWifiOff';
import WifiIcon from '@mui/icons-material/Wifi';
import { Alert, Slide, Snackbar } from '@mui/material';

import { useNetworkStatus } from '@/hooks/useNetworkStatus';

/**
 * Displays a persistent banner when the browser goes offline and a brief
 * "Back online" toast when the connection is restored. Sits at the top
 * center of the viewport so it's impossible to miss.
 */
export const NetworkStatusBanner = () => {
  const { isOnline, wasOffline } = useNetworkStatus();

  return (
    <>
      {/* Offline banner — stays visible the entire time the network is down */}
      <Snackbar
        open={!isOnline}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        TransitionComponent={Slide}
        sx={{ top: '60px !important' }}
      >
        <Alert
          severity="error"
          variant="filled"
          icon={<SignalWifiOffIcon />}
          sx={{ width: '100%', minWidth: 340 }}
        >
          You are offline. Check your internet connection.
        </Alert>
      </Snackbar>

      {/* Reconnected toast — auto-hides after 3 seconds */}
      <Snackbar
        open={isOnline && wasOffline}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        TransitionComponent={Slide}
        sx={{ top: '60px !important' }}
      >
        <Alert
          severity="success"
          variant="filled"
          icon={<WifiIcon />}
          sx={{ width: '100%', minWidth: 340 }}
        >
          Back online — reconnecting...
        </Alert>
      </Snackbar>
    </>
  );
};
